@if (configurationModel.app(); as appData) {
    <div class="carousel" woa-responsive woa-element-width
         woa-swipable [swipeEnabled]="scrollable()" [swipeDirection]="Direction.RIGHT" [bidirectional]="true"
         [swipeMaxDistance]="swipeMaxDistance()" [swipeRangeProportionOfSize]="swipeRangeProportionOfSize()"
         [swipePrimeProportionOfRange]="0.25" [swipeDisengageDelay]="250" [class.ignore-swipe]="ignoreSwipe()"
         (onSwipe)="scroll($event === Direction.LEFT, ScrollType.Swipe)"
         (dblclick)="blockAutoScroll()">
        <div class="carousel-edge left" woa-activatable (onActivate)="scroll(false, ScrollType.Click)">
            @if (scrollable()) {
                <woa-icon-button class="carousel-edge-button" [type]="IconButtonType.LEFT"
                                 (onActivate)="scroll(false, ScrollType.Click)"></woa-icon-button>
            }
        </div>
        <div class="carousel-slides" woa-touchable
             [ngClass]="{
                 'scrollable': scrollable(),
                 'scrolled-back': scrolledBack(),
                 'scrolled-forth': scrolledForth(),
                 'auto-scrolling': scrolling() === ScrollType.Auto,
                 'swipe-scrolling': scrolling() === ScrollType.Swipe,
                 'click-scrolling': scrolling() === ScrollType.Click
             }"
             [woa-css-var]="{
                 '--nr-visible-slides': nrVisibleSlides()
             }">
            @for (slide of visibleSlides(); track slide.slideId) {
                <div class="carousel-slides-slide">
                    @switch (slide.type) {
                        @case (SlideType.Login) {
                            <woa-promo-card [title]="appData.promoteMemberLoginText1"
                                            [message]="appData.promoteMemberLoginText2"
                                            [image]="appData.promoteMemberLoginImage"
                                            [autoCropImage]="appData.promoteMemberLoginImageAutoCrop"
                                            [actionLabel]="'woa.common.login' | translate"
                                            (onActivate)="login()"></woa-promo-card>
                        }
                        @case (SlideType.Deal) {
                            <woa-promo-card [deal]="slide.deal" [showCodeLink]="true"
                                            (onActivate)="onOrderDeal.emit(slide.deal)"></woa-promo-card>
                        }
                        @case (SlideType.Promo) {
                            <woa-promo-card [promo]="slide.promo"
                                            (onActivate)="promoActioned(slide.promo, $event)"></woa-promo-card>
                        }
                        @case (SlideType.More) {
                            <woa-promo-card [actionLabel]="'woa.button.deals.allDeals' | translate"
                                            [autoCropImage]="true" [actionStyle]="AppDealActionStyle.INLINE"
                                            (onActivate)="showAllDeals()"></woa-promo-card>
                        }
                    }
                </div>
            }
        </div>
        <div class="carousel-edge right" woa-activatable (onActivate)="scroll(true, ScrollType.Click)">
            @if (scrollable()) {
                <woa-icon-button class="carousel-edge-button" [type]="IconButtonType.RIGHT"
                                 (onActivate)="scroll(true, ScrollType.Click)"></woa-icon-button>
            }
        </div>
    </div>
}
@if (morePromotionalCards() && !showMorePromotionalCardsAsSlide()) {
    <woa-link [link]="'woa.button.order.moreDeals'" (onActivate)="showAllDeals()"></woa-link>
}
